/**
 * @module address
 * @description Helpers for resume-quote prefill and predictive address suggestions.
 */

const normalizeZipBase = (zip) =>
  String(zip ?? "")
    .replace(/\D/g, "")
    .slice(0, 5);

/**
 * Parse trailing ZIP from resume-quote prefill (`street, ZIP` from useResumeQuoteAddress).
 * @param {string} prefill
 * @returns {string|null} five-digit ZIP base
 */
export const zipFromPrefillAddress = (prefill) => {
  const match = prefill.trim().match(/(\d{5})(?:-\d{4})?\s*$/);
  return match ? match[1] : null;
};

/**
 * Prefer the predictive suggestion that matches the resume quote ZIP when the API
 * returns multiple similar street lines (e.g. same number/name, different states).
 * @template T
 * @param {T[]} suggestions
 * @param {string} prefill
 * @returns {T|undefined}
 */
export const pickSuggestionForPrefill = (suggestions, prefill) => {
  if (!suggestions?.length) return undefined;
  const targetZip = zipFromPrefillAddress(prefill);
  if (!targetZip) return suggestions[0];

  const match = suggestions.find(
    (s) => normalizeZipBase(s.zipCode ?? s.postalCode) === targetZip,
  );
  return match ?? suggestions[0];
};
